module.exports = "<span class=\"product-rating {{class}}\">\n    <i *ngFor=\"let star of [1, 2, 3, 4, 5]\"\n       [ngClass]=\"{\n       'icon-star3':star <= rating,\n       'icon-star-half-full' : star > rating && rating + 1 > star,\n       'icon-star-empty':star >= rating + 1\n       }\">\n    </i>\n</span>"


//////////////////
// WEBPACK FOOTER
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/star-rating/star-rating.component.html
// module id = ../../../../../src/app/star-rating/star-rating.component.html
// module chunks = main